import { Calendar, Flag, MapPin, Users } from "lucide-react";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
// Card components
const Card = ({ children, className = "" }) => (
  <div className={`bg-white p-6 rounded-lg shadow-md ${className}`}>
    {children}
  </div>
);

const CardHeader = ({ children }) => <div className="mb-4">{children}</div>;

const CardTitle = ({ children }) => (
  <h3 className="text-2xl font-bold text-blue-600">{children}</h3>
);

const CardContent = ({ children }) => (
  <div className="text-gray-700 text-lg">{children}</div>
);

// EventCard component using the Card components
const EventCard = ({ title, children }) => (
  <Card className="h-full bg-gray-50 hover:bg-gray-100 transition-colors duration-300">
    <CardHeader>
      <CardTitle>{title}</CardTitle>
    </CardHeader>
    <CardContent>{children}</CardContent>
  </Card>
);

// IconText component for displaying icons with text
const IconText = ({ Icon, text }) => (
  <div className="flex items-center space-x-2">
    <Icon className="w-6 h-6 text-blue-500" />
    <span className="text-gray-800">{text}</span>
  </div>
);

// Utility function to shuffle an array
const shuffleArray = (array) => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

const  AchivementsDetailPage= ()=> {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Original images
  const images = useMemo(
    () =>
      shuffleArray([
        "https://i.ibb.co/DwrxYXz/IMG-3355.jpg",
        "https://i.ibb.co/RY0QSCX/IMG-20240530-WA0031-EATI-RUPENDRASRIVINAYGAR.webp",
        "https://i.ibb.co/HYxLMg0/Whats-App-Image-2024-08-08-at-10-44-49-AM.webp",
        "https://i.ibb.co/1Qty61K/a9cab410-561f-4192-93e4-ff7f38f9cf5a.webp",
        "https://i.ibb.co/1Qty61K/a9cab410-561f-4192-93e4-ff7f38f9cf5a.webp",
        "https://i.ibb.co/HYxLMg0/Whats-App-Image-2024-08-08-at-10-44-49-AM.webp",
        "https://i.ibb.co/RY0QSCX/IMG-20240530-WA0031-EATI-RUPENDRASRIVINAYGAR.webp",
        "https://i.ibb.co/2cr0t6D/Whats-App-Image-2024-08-08-at-10-43-56-AM.webp",
      ]),
    []
  );

  const changeImage = useCallback(() => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  }, [images.length]);

  useEffect(() => {
    const intervalId = setInterval(changeImage, 5000);
    return () => clearInterval(intervalId);
  }, [changeImage]);

  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900 p-12 lg:p-8">
      <main className="space-y-12">
        {/* Page Header */}
        <div className="mt-4 text-center">
          <h1 className="text-4xl font-bold text-gray-900 dark:text-gray-100">
            Independent Celebration
          </h1>
          <p className="text-xl mt-2 text-gray-600 dark:text-gray-400 italic">
            Uniting Cultures, Inspiring Futures
          </p>
        </div>

        {/* Image Slider and Event Details */}
        <div className="grid gap-8 md:grid-cols-2">
          {/* Image Slider */}
          <div className="relative h-[400px] rounded-lg overflow-hidden shadow-lg">
            {images.map((src, index) => (
              <img
                key={src}
                src={src}
                alt={`Event ${index + 1}`}
                className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ${
                  index === currentImageIndex ? "opacity-100" : "opacity-0"
                }`}
              />
            ))}
          </div>

          {/* Event Details */}
          <div className="flex flex-col h-[400px] space-y-6">
            {/* Scrollable Text Section */}
            <div className="flex-1 overflow-auto">
              <p className="text-lg  p-2 text-gray-700 dark:text-gray-300">
                <p>
                  Our annual Independent Celebration is a cornerstone event that
                  brings together Gambian and Indian cultures in a vibrant
                  display of unity and diversity. This achievement represents
                  our commitment to fostering cross-cultural understanding and
                  creating lasting bonds between our communities. Our annual
                  Independent Celebration is a cornerstone event that brings
                  together Gambian and Indian cultures in a vibrant display of
                  unity and diversity."
                </p>
                <br />
                <p>
                  This achievement represents our commitment to fostering
                  cross-cultural understanding and creating lasting bonds
                  between our communities.Our annual Independent Celebration is
                  a cornerstone event that brings together Gambian and Indian
                  cultures in a vibrant display of unity and diversity. This
                  achievement represents our commitment to fostering
                  cross-cultural understanding and creating lasting bonds
                  between our communities.Our annual Independent Celebration is
                  a cornerstone event that brings together Gambian and Indian
                  cultures in a vibrant display of unity and diversity.
                </p>
                <br />
                <p>
                  This achievement represents our commitment to fostering
                  cross-cultural understanding and creating lasting bonds
                  between our communities.Our annual Independent Celebration is
                  a cornerstone event that brings together Gambian and Indian
                  cultures in a vibrant display of unity and diversity. This
                  achievement represents our commitment to fostering
                  cross-cultural understanding and creating lasting bonds
                  between our communities.Our annual Independent Celebration is
                  a cornerstone event that brings together Gambian and Indian
                  cultures in a vibrant display of unity and diversity.
                </p>
                <br />
                <p>
                  This achievement represents our commitment to fostering
                  cross-cultural understanding and creating lasting bonds
                  between our communities.Our annual Independent Celebration is
                  a cornerstone event that brings together Gambian and Indian
                  cultures in a vibrant display of unity and diversity. This
                  achievement represents our commitment to fostering
                  cross-cultural understanding and creating lasting bonds
                  between our communities.Our annual Independent Celebration is
                  a cornerstone event that brings together Gambian and Indian
                  cultures in a vibrant display of unity and diversity.
                </p>
                <br />
                <p>
                  This achievement represents our commitment to fostering
                  cross-cultural understanding and creating lasting bonds
                  between our communities.Our annual Independent Celebration is
                  a cornerstone event that brings together Gambian and Indian
                  cultures in a vibrant display of unity and diversity. This
                  achievement represents our commitment to fostering
                  cross-cultural understanding and creating lasting bonds
                  between our communities.Our annual Independent Celebration is
                  a cornerstone event that brings together Gambian and Indian
                  cultures in a vibrant display of unity and diversity. This
                  achievement represents our commitment to fostering
                  cross-cultural understanding and creating lasting bonds
                  between our communities.
                </p>
              </p>
            </div>

            {/* Non-Scrollable Icons Section */}
            <div className="grid grid-cols-2 gap-4">
              <IconText Icon={Calendar} text="Annual Celebration" />
              <IconText Icon={MapPin} text="Multiple Venues" />
              <IconText Icon={Users} text="180+ Attendees" />
              <IconText Icon={Flag} text="Cultural Exchange" />
            </div>
          </div>
        </div>

        {/* Event Highlights and Upcoming Events */}
        <div className="grid gap-8 md:grid-cols-2">
          <EventCard title="Event Highlights">
            <ul className="list-disc list-inside space-y-2">
              <li>
                Traditional dance performances from both Gambian and Indian
                cultures
              </li>
              <li>
                Culinary exchange featuring authentic dishes from both countries
              </li>
              <li>
                Art exhibitions showcasing local and international talents
              </li>
              <li>
                Cultural workshops promoting hands-on learning experiences
              </li>
              <li>
                Guest speakers discussing the importance of cultural diversity
              </li>
            </ul>
          </EventCard>

          {/* Upcoming Events */}
          <EventCard title="Upcoming Events">
            <div className="space-y-4">
              <div>
                <h3 className="font-semibold text-gray-900 dark:text-gray-100">
                  Gambian Night
                </h3>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  A night of Gambian music, dance, and cuisine.
                </p>
                <p className="text-sm">Date: August 15, 2024</p>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900 dark:text-gray-100">
                  Indian Cultural Workshop
                </h3>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  Learn about Indian traditions, art, and history.
                </p>
                <p className="text-sm">Date: September 5, 2024</p>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900 dark:text-gray-100">
                  Joint Independence Day Celebration
                </h3>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  Commemorating the independence of both nations.
                </p>
                <p className="text-sm">Date: October 2, 2024</p>
              </div>
            </div>
          </EventCard>
        </div>

        {/* Event Gallery */}
        <section>
          <h2 className="text-3xl font-semibold text-gray-900 dark:text-gray-100 mb-6">
            Event Gallery
          </h2>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
            {images.slice(0, 8).map((src, index) => (
              <div
                key={index}
                className="relative aspect-square rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-all duration-300 hover:scale-105"
              >
                <img
                  src={src}
                  alt={`Event ${index + 1}`}
                  className="w-full h-full object-cover"
                />
              </div>
            ))}
          </div>
          <div className="mt-12 text-center">
            <Link
              to="/gallery"
              className="inline-flex items-center px-4 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors duration-300"
            >
              View Full Gallery
            </Link>
          </div>
        </section>
      </main>
    </div>
  );
};
export default AchivementsDetailPage;
